import { StateTag } from '@framework/common-web/register-records/component/StateTag.tsx';
import { type StatoIscrizioneDTO } from '@framework/common-web/register-records/frontoffice/api/schemas/statoIscrizioneDTO.ts';

interface IVerifyPassStateTagProps {
  state?: StatoIscrizioneDTO | null;
}

/**
 * Stato di un Tesserino
 */
export function VerifyPassStateTag(props: IVerifyPassStateTagProps) {
  const { state } = props;

  if (!state?.codice) return null;

  return (
    <StateTag
      state={state.denominazione ?? state.codice}
      color={state.colore || undefined}
      icon={state.icona || undefined}
    />
  );
}
